import {
  initialState,
  Actions,
  State,
  GET_USER_INFORMATION,
  GET_USER_INFORMATION_SUCCESS,
  GET_USER_INFORMATION_ERROR,
  UPDATE_CURRENT_USER_INFORMATION,
  UPDATE_CURRENT_USER_INFORMATION_SUCCESS,
  UPDATE_CURRENT_USER_INFORMATION_ERROR,
  RESET_USER_INFORMATION
} from "../../types/user/get-user-information";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case GET_USER_INFORMATION:
      return {
        ...state,
        data: state.data,
        states: {
          success: false,
          loading: true,
          error: false,
        },
      };
    case GET_USER_INFORMATION_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          success: true,
          loading: false,
          error: false,
        },
      };
    case GET_USER_INFORMATION_ERROR:
      return {
        ...state,
        data: null,
        states: {
          success: false,
          loading: false,
          error: action.payload,
        },
      };
    case UPDATE_CURRENT_USER_INFORMATION:
      return {
        ...state,
        data: state.data,
        states: {
          success: false,
          loading: false,
          error: false,
        },
      };
    case UPDATE_CURRENT_USER_INFORMATION_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          success: false,
          loading: false,
          error: false,
        },
      };
    case UPDATE_CURRENT_USER_INFORMATION_ERROR:
      return {
        ...state,
        data: state.data,
        states: {
          success: false,
          loading: false,
          error: false,
        },
      };
    case RESET_USER_INFORMATION:
      return initialState;
    default:
      return state;
  }
};

export default reducers;
